export enum MICROSERVICES {
  CORE = 'CORE',
  AUTH = 'AUTH'
}
